<template>
  <div>
    <div class="row sticky-button">
      <div class="px-3">
        <div class="form-group has-label">
          <label class="row"
            ><h4 class="d-flex align-self-center">
              {{ $t('sigatoka.plants') }}:
            </h4>
            <strong class="d-flex align-self-center pl-2 pt-3">{{
              model.plants_count
            }}</strong>
          </label>
        </div>
      </div>
    </div>
    <div
      v-for="plantindex in model.plants_count"
      :key="plantindex"
      class="row py-3 mb-4 shadow-sm"
      style="border: 0.5px solid #6ba6524d"
    >
      <div class="col-11 col-md-11">
        <div class="row">
          <div class="col-12 col-md-2 col-lg-1 col-xl-2">
            <fg-input
              disabled
              class="pl-0"
              type="number"
              v-model="model.plant[plantindex - 1]"
              :label="`${$t('sigatoka.plant')} ${model.plant[plantindex - 1]}:`"
            ></fg-input>
          </div>
          <div class="col-12 col-md-2 col-lg-3 col-xl-2">
            <fg-input
              type="number"
              placeholder="..."
              @keypress="validateInput"
              v-model="model.functional_leaf[plantindex - 1]"
              :label="`${$t('sigatoka.total_functional_leaves')}: *`"
              :class="`pl-0 required-functional_leaf-${plantindex - 1}`"
            ></fg-input>
          </div>
          <div class="col-12 col-md-2 col-lg-2 col-xl-2">
            <fg-input
              type="number"
              placeholder="..."
              @keypress="validateInput"
              v-model="model.ref[plantindex - 1]"
              :label="`${$t('sigatoka.ref')}: *`"
              :class="`pl-0 required-ref-${plantindex - 1}`"
            ></fg-input>
          </div>
        </div>
        <hr />
        <div class="row pr-3">
          <div
            class="col-12 col-md-2 col-lg-2 col-xl-2"
            v-for="(leaf, leafindex) in model.leaves"
            :key="leafindex"
          >
            <fg-input
              type="number"
              placeholder="..."
              @keypress="validateInput"
              :label="`${$t('sigatoka.leaf')} ${leaf}: *`"
              v-model="model.infection[plantindex - 1][leafindex]"
              :class="`pl-0 required-leaf-${plantindex - 1}-${leafindex}`"
            ></fg-input>
          </div>
        </div>
      </div>
      <div
        class="col-1 col-md-1 d-flex justify-content-center align-items-center"
      >
        <div
          class="col-1 col-md-1 col-lg-1 d-flex justify-content-center align-items-center"
        >
          <div class="btn-group" role="group">
            <button
              class="btn btn-danger custom-shadow-btn mr-2"
              @click.prevent="
                handleDelete(
                  plantindex - 1,
                  model.functional_leaf[plantindex - 1],
                  model.ref[plantindex - 1],
                  model.infection[plantindex - 1]
                )
              "
            >
              <em class="fa fa-minus"></em>
            </button>

            <button
              v-if="plantindex === model.plants_count"
              @click.prevent="handlePlus(plantindex - 1)"
              class="btn btn-success custom-shadow-btn"
            >
              <em class="fa fa-plus"></em>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  data() {
    return {
      model: {
        ids: {},
        ref: [],
        leaves: [],
        plant: [1],
        infection: [],
        plant_ids: [],
        deleted_ids: [],
        plants_count: 1,
        key: 'fifth_step',
        functional_leaf: [],
      },
    };
  },
  methods: {
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          for (let i = 0; i < this.model.plants_count; i++) {
            if (!isset(this.model.functional_leaf[i]))
              return this.validationInputsRequired(`functional_leaf-${i}`);
            if (!isset(this.model.ref[i]))
              return this.validationInputsRequired(`ref-${i}`);
            for (let j = 0; j < this.model.leaves.length; j++) {
              if (!isset(this.model.infection[i][j]))
                return this.validationInputsRequired(`leaf-${i}-${j}`);
            }
          }
          this.$emit('on-validated', this.model);

          return isValid;
        }
      });
    },
    handleDelete(index, functional_leaves, ref, leaves_values) {
      if (functional_leaves || ref || leaves_values) {
        SweetAlert.delete('row').then((result) => {
          if (result.value) this.handleMinus(index);
        });
      } else {
        this.handleMinus(index);
      }
    },
    handlePlus(index) {
      this.model.plants_count++;
      const i = this.model.plant[index];
      this.model.plant.push(i + 1);
      const tempKey = `temp_${Date.now()}`;
      this.model.plant_ids.push(tempKey);
      this.$set(this.model.ids, tempKey, []);
      this.model.infection.push(Array(this.model.leaves.length).fill(null));
    },
    handleMinus(index) {
      const minNumber = 1;
      if (this.model.plants_count > minNumber) {
        this.model.plants_count--;
        this.model.ref.splice(index, 1);
        this.model.plant.splice(index, 1);
        this.model.infection.splice(index, 1);
        this.model.functional_leaf.splice(index, 1);
        const plantKey = this.model.plant_ids[index];
        if (!String(plantKey).startsWith('temp_'))
          this.model.deleted_ids.push(plantKey);
        this.$delete(this.model.ids, plantKey);
      } else {
        this.model.plant = [1];
        this.model.ref = [null];
        this.model.plants_count = 1;
        this.model.functional_leaf = [null];
        this.model.infection = [Array(this.model.leaves.length).fill(null)];
        this.model.ids = {};
      }
    },
    validateInput(event) {
      const input = String.fromCharCode(event.which);
      if (!/[0-9,.]/.test(input)) event.preventDefault();
    },
  },
  created() {
    this.showHideLoading(true);
    this.model.infection.push(Array(this.model.leaves.length).fill(null));
    const model = JSON.parse(localStorage.getItem('model'));
    if (!model) return false;
    this.model.farm_id = model.farm_id;
    this.model.route = 'sigatoka/capture/config';
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.postMasters(this.model)])
        .then(([responseConfig]) => {
          const config = responseConfig.data.data;
          config.sigatoka_config_leaves.forEach((leaves) => {
            this.model.leaves.push(leaves.leaf);
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
